import PropTypes from "prop-types";
import {Select} from "antd";

const STATUS_OPTIONS = [
    { value: "ALL", label: "Все статусы" },
    { value: "DRAFT", label: "Draft" },
    { value: "PUBLISHED", label: "Published" },
    { value: "ARCHIVED", label: "Archived" },
];

export default function VersionStatusFilter({ value, onChange, disabled }) {
    return (
        <div className="flex flex-col">
            <label className="eyebrow mb-1 text-xs font-medium text-zinc-400">Статус</label>
            {/* Альтернатива с использованием Ant Design Select */}
            <Select
                value={value}
                onChange={onChange}
                placeholder="Выберите статус"
                disabled={disabled}
                className="w-full"
            >
                {STATUS_OPTIONS.map((option) => (
                    <Select.Option key={option.value} value={option.value}>
                        {option.label}
                    </Select.Option>
                ))}
            </Select>
        </div>
    );
}

VersionStatusFilter.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};
